import React, { useState } from "react";

interface DropdownOption {
  id: string;
  name: string;
}

interface DropdownProps {
  options: DropdownOption[];
  onAddOption: (option: string, name?: string) => void;
  name: string
  otherClasses?: string
}

const SearchableDropdown: React.FC<DropdownProps> = ({
  options,
  onAddOption,
  name,
  otherClasses
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState(options);
  const [showDropDown, setShowDropDown] = useState(false);

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement> | string
  ) => {
    setShowDropDown(true)
    setSearchValue(typeof e === "string" ? e : e.target.value);
    onAddOption(typeof e === "string" ? e : e.target.value);
  };

  const handleAddOption = () => {
    const newOption: DropdownOption = {
      id: searchValue,
      name: searchValue,
    };
    setDropdownOptions([...dropdownOptions, newOption]);
    handleSearchChange(newOption.name);
    setShowDropDown(!showDropDown)
  };

  const filteredOptions = dropdownOptions.filter((option) =>
    option.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <div className="relative">
      <input
        type="text"
        value={searchValue}
        name={name}
        onChange={handleSearchChange}
        onFocus={()=>setShowDropDown(true)}
        onBlur={() => setTimeout(() => setShowDropDown(false), 200)} //added to trigger after onClick event of below DIV
        placeholder="Search or add..."
        className={`w-full px-3 py-2 border rounded-md focus:outline-none ${otherClasses}`}
      />
      {showDropDown && <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-40 overflow-y-auto">
        {filteredOptions.length > 0 ? (
          filteredOptions.map((option) => {
            return (
            <div
              key={option.id}
              className="px-3 py-2 cursor-pointer hover:bg-blue-100"
              onClick={() => {
                handleSearchChange(option.name)
                setShowDropDown(false)
            }}
            >
              {option.name}
            </div>
          )})
        ) : (
          <div className="px-3 py-2 text-gray-500">No options found</div>
        )}
        {searchValue &&
          !dropdownOptions.some((option) => option.name === searchValue) && (
            <div
              className="px-3 py-2 text-blue-500 cursor-pointer hover:bg-blue-100"
              onClick={handleAddOption}
            >
              {`Add "${searchValue}"`}
            </div>
          )}
      </div>}
    </div>
  );
};

export default SearchableDropdown;
